import _ from "lodash";

export const signOptions = [
  { value: "+", label: "+" },
  { value: "-", label: "-" }
];

export const deliveryDaysOptions = _.range(0, 6).map(r => ({
  value: r,
  label: r
}));
